import { UnderlyingPriceExitLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/UnderlyingPriceExitLine';
import { UnderlyingPriceExitTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/underlyingPriceExit/UnderlyingPriceExitTacticPanel';
import { AddUnderlyingPriceExitTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddUnderlyingPriceExitTacticPanel';
import { UnderlyingPriceExitWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/UnderlyingPriceExitModule/UnderlyingPriceExitWrapper';
import { UnderlyingPriceExitDocumentation } from '../../../../components/forms/tradeplans/documentation/UnderlyingPriceExitDocumentation';
import { UnderlyingPriceExitModule } from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/UnderlyingPriceExitModule';
import { UnderlyingPriceExitData } from './underlyingPriceExitData';
import { validateUnderlyingPriceExit } from './validateUnderlyingPriceExit';

export const UnderlyingPriceExit = {
  //data class
  dataStore: UnderlyingPriceExitData,

  //string constants
  name: 'UNDERLYING_PRICE_EXIT',
  tacticLabel: 'Underlying Price Exit',
  addTacticLabel: 'Add Underlying Price Exit',
  category: 'Exit',

  // components
  tradePlanFormModule: UnderlyingPriceExitModule,
  tacticPanel: UnderlyingPriceExitTacticPanel,
  addTacticPanel: AddUnderlyingPriceExitTacticPanel,
  wrapper: UnderlyingPriceExitWrapper,
  chartSoftOrderComponent: UnderlyingPriceExitLine,
  documentation: UnderlyingPriceExitDocumentation,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateUnderlyingPriceExit,
};
